module.exports = __webpack_public_path__ + "img/grupTurcoaz.b125cdb5.svg";